<template>
  <PriceBoxTripPlan v-if="!isBookableTrip" @customTrip="emit('customTrip')" @scrollToInclusions="emit('scrollToInclusions')" />
  <PriceBoxBookable
    v-else-if="!isCompleted && !isZeroGroupTrip"
    @customTrip="emit('customTrip')"
    @openTermBox="emit('openTermBox')"
    @handleBook="handleBook"
    @confirmDate="emit('confirmDate')"
    @scrollToInclusions="emit('scrollToInclusions')"
  />
  <div
    id="floatPriceBox"
    v-if="priceFloatingVisible && !isDesktop && !dataTrip.is_booked"
    :class="['fixed wp-100 left-0 bottom-0 py-15 z-998', bgFloatClass ? bgFloatClass : 'bg-white', isBookableTrip ? '' : 'price-floating-visible ']"
  >
    <div :class="['container flex flex-row items-center justify-between']">
      <template v-if="domain !== 'agent'">
        <div :class="['flex flex-row items-center', 'wp-100 justify-between']">
          <div :class="['flex', 'flex-column items-start']">
            <template v-if="!isDesktop">
              <DJButton :icon="IconExport" @click.prevent="emit('share')" size="large" type="secondary"> </DJButton>
            </template>
          </div>
          <div class="ml-20" :class="!isDesktop && 'wp-100'">
            <DJButton v-if="isCompleted" class="wp-100" size="large">
              <router-link class="" :to="{ name: 'feedback', params: { id: dataTrip.id, point: 9 } }">
                Rate my trip with {{ dataTrip?.designer?.name }}
              </router-link>
            </DJButton>
            <DJButton
              v-else-if="showButtonConfirmDate"
              id="button-bookable-trip-plan-confirm-travel-date"
              class="wp-100"
              :type="dataTrip?.valid_time && showCountDown ? 'warning' : 'accent'"
              size="large"
              @click.prevent="$emit('confirmDate')"
            >
              Confirm Your Travel Date
            </DJButton>
            <TripButton v-else customClass="wp-100" :buttonID="idTrackingEnquiryButtonBottom" @customTrip="$emit('customTrip')" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { onBeforeRouteLeave, useRoute } from 'vue-router'
import { ref, computed, inject, nextTick, onMounted, onUnmounted } from "vue"
import PriceBoxTripPlan from '~/components/pages/TripPlanDetail/sections/SectionTripPriceBox/PriceBoxTripPlan.vue'
import PriceBoxBookable from '~/components/pages/TripPlanDetail/sections/SectionTripPriceBox/PriceBoxBookable.vue'
import TripButton from '~/components/pages/TripPlanDetail/sections/SectionTripPriceBox/TripButton'
import DJButton from '~/components/ui/button/Button.vue'
import { IconExport } from '~/components/ui/icon/icons'
import { DESKTOP } from '~/constant/common'
import { isEmpty, publicDomain } from '~/helper'
import { onIntersect } from '~/helper/useCheckVisibleInViewport'
import { useTripPlanStore } from '~/store/pinia/tripPlan'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

const props = defineProps({
  bgFloatClass: {
    type: String,
    default: '',
  },
  checked: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['customTrip', 'openTermBox', 'handleBook', 'share', 'scrollToInclusions', 'confirmDate'])

const route = useRoute()
const domain = publicDomain()
const tripPlanStore = useTripPlanStore()
const generalStore = useGeneralInfoStore()

const isExpired = inject('isExpired', false)
const showCountDown = inject('showCountDown', false)

const windowWidth = computed(() => generalStore.generalData.windowWidth)
const isDesktop = computed(() => windowWidth.value >= DESKTOP)

const dataTrip = computed(() => tripPlanStore.dataTrip)
const isBookableTrip = computed(() => dataTrip?.value?.type === 'bookable')
const isZeroGroupTrip = computed(() => tripPlanStore.isZeroGroupTrip)
const isCompleted = computed(() => tripPlanStore.isCompleted)
const showButtonConfirmDate = computed(() => !dataTrip.value?.is_defined_date && !dataTrip.value?.is_booked && !isExpired.value && isBookableTrip.value)

const idTrackingEnquiryButtonBottom = computed(() => {
  if (route.name === 'trip-plan') return 'gallery-trip-plan-button-enquire-bottom'
  return ''
})
const topPriceVisible = ref({})
const priceFloatingVisible = ref(false)

function handleBook(data) {
  emit('handleBook', data)
}
function onEnter() {
  priceFloatingVisible.value = false
  const element = document.getElementById('dj-app')
  const style = element?.style
  if (style) element.removeAttribute('style')
}
function onExit() {
  if (window.pageYOffset > 0) priceFloatingVisible.value = true

  nextTick(() => {
    let ele = 0

    const eleFloatPrice = document.getElementById('floatPriceBox')
    if (!isEmpty(eleFloatPrice)) {
      ele = eleFloatPrice.offsetHeight
    }
    const eleFooter = document.getElementById('main-footer')
    if (eleFooter !== null) {
      eleFooter.style.paddingBottom = `${ele}px`
    }
  })
}


onMounted(() => {
  const element = isCompleted.value
    ? document.getElementById('rate-box')
    : isBookableTrip.value
    ? document.getElementById('bookable-box')
    : document.getElementById('trip-plan-box')
  if ((domain === 'traveller' || (domain === 'agent' && isBookableTrip.value) || domain === 'preview') && element)
    topPriceVisible.value = onIntersect(element, onEnter, onExit, false, { rootMargin: '-70px 0px 0px 70px', threshold: 0 }, true)
})

onBeforeRouteLeave(() => {
  onEnter()
})

onUnmounted(() => {
  if (domain === 'traveller' || domain === 'preview') {
    topPriceVisible.value.disconnect()
    const element = document.getElementById('dj-app')
    const style = element?.style
    if (style) element.removeAttribute('style')
    generalStore.setCustomClassChat('')
  }
})
</script>
<style lang="scss" scoped>
.price-floating-visible {
  //position: fixed; width: 100%;
  filter: drop-shadow(0px 4px 44px rgba(0, 0, 0, 0.1));
  //@include phone {
  //  .season-label {display: none}
  //}
}
a:link,
a:visited,
a:hover,
a:active,
a:focus {
  color: unset;
}
</style>
